import React, { useState, useEffect } from 'react'
import NumberInput from '../../../elements/NumberInput/NumberInput'
import {
  checkForEmpty,
  checkRegEx,
  checkStartWithZero,
} from '../../helpers/checkers'
import floorFigure from '../../helpers/floorFigure'
import { regexes } from '../../helpers/regex'

export default function WinChanceInput({ handleChance, value }: any) {
  const [chanceValue, setChanceValue] = useState('')

  const handleChange = (value: any) => {
    // const value = e.target.value
    if (checkRegEx(value, regexes.wholeNumbers)) {
      setChanceValue(value)
    }
  }
  const handleBlur = (s: any) => {
    const value = s.target.value
    if (checkForEmpty(+value)) {
      return handleChance('0')
    } else {
      handleChance((+value).toFixed())
      if (!value.includes('%')) {
        setChanceValue(`${(+value).toFixed()}%`)
      }
    }
  }
  useEffect(() => {
    setChanceValue(`${(+value).toFixed()}%`)
  }, [value])

  return (
    <NumberInput
      value={chanceValue}
      handleBlur={handleBlur}
      handleChange={handleChange}
      title='WIN CHANCE'
      placeholder={'50%'}
      readOnly
    />
  )
}
